import { Component } from '@angular/core';

import { StoreService } from './../../../services/store.service';

@Component({
  selector: 'app-maintenance-scroller',
  templateUrl: './maintenance-scroller.component.html',
  styleUrls: ['./maintenance-scroller.component.scss']
})
export class MaintenanceScrollerComponent {
  constructor(public globalStore: StoreService) {}

  get messages(): string[] {
    return this.globalStore.maintenanceConfig.banner.messages || [];
  }

  get message_head(): string {
    return this.globalStore.maintenanceConfig.banner.message_head || 'Important notice:';
  }
}
